"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderLink = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _constants = require("../../button/constants");
var _context = require("../../context");
var _layout = require("../../layout");
var _link = require("../../link");
var _propTypes = require("../../prop-types");
var _utils = require("../../utils");
var _PageHeaderContext = require("./PageHeaderContext");
var _constants2 = require("./constants");
var _interfaces = require("./interfaces");
var _core = require("@emotion/core");
var _excluded = ["children", "hasHover", "icon", "isSelected", "paddingHorizontal", "wrapper"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var styleCallback = function styleCallback(_ref) {
  var selectors = _ref.theme.selectors,
    colorScheme = _ref.colorScheme,
    isSelected = _ref.isSelected,
    hasHover = _ref.hasHover;
  var isInverted = colorScheme === _interfaces.PageHeaderColorScheme.Inverted;
  var color = selectors.color(isInverted ? 'neutral90' : 'neutral0');
  var hoverBackgroundColor = selectors.color(isInverted ? 'neutral10' : 'neutral80');
  var activeBackgroundColor = selectors.color(isInverted ? 'neutral20' : 'neutral70');
  var outlineColor = selectors.color(isInverted ? 'primary70' : 'primary30');
  var borderRadius = selectors.radius(_constants2.PAGE_HEADER_ITEM_RADIUS);
  return _objectSpread(_objectSpread({
    color: color,
    height: '100%',
    borderRadius: borderRadius,
    paddingTop: (0, _utils.px)(_constants2.PAGE_HEADER_LINK_SELECTION_INDICATOR_HEIGHT),
    paddingBottom: (0, _utils.px)(_constants2.PAGE_HEADER_LINK_SELECTION_INDICATOR_HEIGHT),
    position: 'relative',
    transition: 'background-color .2s ease 0s'
  }, isSelected && {
    ':after': {
      content: '""',
      width: '100%',
      height: _constants2.PAGE_HEADER_LINK_SELECTION_INDICATOR_HEIGHT,
      backgroundColor: color,
      position: 'absolute',
      bottom: 0,
      left: 0,
      borderRadius: borderRadius
    },
    ':focus:after': {
      borderRadius: "0 0 ".concat((0, _utils.px)(borderRadius), " ").concat((0, _utils.px)(borderRadius))
    }
  }), {}, {
    ':focus': {
      outline: 'none'
    },
    ':focus-visible': {
      outline: "".concat((0, _utils.px)(_constants.OUTLINE_WIDTH), " solid ").concat(outlineColor),
      outlineOffset: _constants.OUTLINE_OFFSET
    },
    ':hover': _objectSpread({
      color: color,
      textDecoration: 'none'
    }, hasHover ? {
      backgroundColor: hoverBackgroundColor
    } : {}),
    ':active': {
      backgroundColor: activeBackgroundColor
    }
  });
};
var PageLinkWrapper = (0, _context.styledWithTheme)( /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return (0, _core.jsx)(_link.Link, (0, _extends2.default)({}, props, {
    ref: ref
  }));
}))(styleCallback);
var PageHeaderLinkWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
    hasHover = _ref2.hasHover,
    icon = _ref2.icon,
    isSelected = _ref2.isSelected,
    _ref2$paddingHorizont = _ref2.paddingHorizontal,
    paddingHorizontal = _ref2$paddingHorizont === void 0 ? _constants2.PageHeaderLinkDefaultProps.paddingHorizontal : _ref2$paddingHorizont,
    _ref2$wrapper = _ref2.wrapper,
    Wrapper = _ref2$wrapper === void 0 ? PageLinkWrapper : _ref2$wrapper,
    forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var _useContext = (0, _react.useContext)(_PageHeaderContext.PageHeaderContext),
    colorScheme = _useContext.colorScheme;
  return (0, _core.jsx)(Wrapper, (0, _extends2.default)({
    padding: [0, paddingHorizontal],
    fontWeight: "regular",
    textDecoration: "none",
    colorScheme: colorScheme,
    "aria-current": isSelected ? 'page' : 'false',
    isSelected: isSelected,
    color: colorScheme === _interfaces.PageHeaderColorScheme.Inverted ? 'neutral100' : 'neutral0',
    hasHover: hasHover,
    ref: ref
  }, forwardedProps), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: "S200",
    height: "100%"
  }, !!icon && icon, !!children && children));
});
var PageHeaderLinkStyled = PageHeaderLinkWithoutDocs;
PageHeaderLinkStyled.withComponent = function (tag) {
  var Wrapper = (0, _context.styledWithTheme)(_link.Link.withComponent(tag, {
    target: "elyco8w0"
  }))(styleCallback);
  return function (props) {
    return (0, _core.jsx)(PageHeaderLink, (0, _extends2.default)({}, props, {
      wrapper: Wrapper
    }));
  };
};
var PageHeaderLinkWithDocs = (0, _stencilReactDesc.describe)(PageHeaderLinkStyled).description('Link for page header.');
PageHeaderLinkWithDocs.defaultProps = _objectSpread({}, _constants2.PageHeaderLinkDefaultProps);
PageHeaderLinkWithDocs.propTypes = {
  paddingHorizontal: (0, _propTypes.cssValue)().description('Sets the horizontal (left and right) padding.'),
  icon: _stencilReactDesc.PropTypes.node.description('Adds an icon to the left side of the link.'),
  children: _stencilReactDesc.PropTypes.node.description('Content of the link.'),
  isSelected: _stencilReactDesc.PropTypes.bool.description('Determines whether to add an indication that the link represents the currently selected page.')
};
var PageHeaderLink = (0, _utils.withTestAttributes)({
  component: 'StencilReactPageHeaderLink'
})(PageHeaderLinkWithDocs);
exports.PageHeaderLink = PageHeaderLink;
PageHeaderLink.displayName = 'PageHeaderLink';